module.exports = "/_next/static/images/the-boston-globe-1787a2a688f1c77fab79d05965e2939c.png";